import { APP_HEADER_HEIGHT_VAR, HeaderContent, HEADER_TITLE_CLASS } from '../../../components/shell/app-header';

export default function RelectureComprehensionApp() {
  return (
    <>
      <HeaderContent width="md" showBurger backTo="/mini-apps/francais-college" backLabel="Français collège">
        <div className="min-w-0">
          <h1 className={HEADER_TITLE_CLASS}>Relecture — Compréhension (outil enseignant)</h1>
          <p className="m-0 mt-0.5 text-[13px] leading-snug text-[color:var(--naia-text-secondary)]">
            Brouillon à valider, rien n'est enregistré ; l'export JSON est le seul moyen de conserver vos décisions.
          </p>
        </div>
      </HeaderContent>
      <iframe
        src="/mini-apps/francais-college/relecture_module_comprehension.html"
        title="Relecture — Compréhension (outil enseignant)"
        className="w-full border-0"
        style={{ height: `calc(100dvh - var(${APP_HEADER_HEIGHT_VAR}, 0px))` }}
        sandbox="allow-scripts allow-downloads"
      />
    </>
  );
}
